import React, { useEffect, useState } from 'react';
import { properties } from '../../properties';
import SoapResponse from "../SoapResponse";
import ErrorPage from '../../ErrorPage';
import LoaderComp from '../LoaderComp';
import transidgenerator from '../../transidgenerator';
import $ from "jquery";

function SoapVoidAuth({ apiUrl }) {
    const [soapVoidAuth, setSoapVoidAuth] = useState({
        operation: properties.OPERATIONS.voidAuthorise,
        vendorid: properties.VENDOR_ID,
        transactionid: transidgenerator(),
        userid: properties.USER_ID,
        method: properties.SOAP_METHOD,
        customerPresent: properties.CUSTOMER_PRESENT,
        token: properties.TOKEN,
        authCode: properties.AUTHCODE,
        description: properties.DESCRIPTION,
        currency: properties.CURRENCY,
        timestamp: "",
        region: properties.SEL_REGION,
        password: properties.PASSWORD,
        security: ""
    });

    var canSubmit = true;

    function isNotNullCheck(e, field) {
        if (e === "" || !e) {
            document.getElementsByName(field)[0].classList.add("emptied");
            document.getElementsByName(field)[1].classList.add("emptied");
            canSubmit = false;
        }
        else {
            document.getElementsByName(field)[0].classList.remove("emptied");
            document.getElementsByName(field)[1].classList.remove("emptied");
        }
    }

    const [response, setResponse] = useState();

    function changeTransactionId(e) {
        isNotNullCheck(e.target.value, "WPG_transID");
        setSoapVoidAuth({ ...soapVoidAuth, transactionid: e.target.value });
    }

    function changeVendorId(e) {
        isNotNullCheck(e.target.value, "WPG_vendorID");
        setSoapVoidAuth({ ...soapVoidAuth, vendorid: e.target.value });
    }

    function changePwd(e) {
        isNotNullCheck(e.target.value, "vendorPwd");
        setSoapVoidAuth({ ...soapVoidAuth, password: e.target.value });
    }

    function changeMethod(e) {
        isNotNullCheck(e.target.value, "WPG_method");
        setSoapVoidAuth({ ...soapVoidAuth, method: e.target.value });
    }

    function changeDesc(e) {
        isNotNullCheck(e.target.value, "WPG_description");
        setSoapVoidAuth({ ...soapVoidAuth, description: e.target.value });
    }

    function changeCurrency(e) {
        isNotNullCheck(e.target.value, "WPG_currency");
        setSoapVoidAuth({ ...soapVoidAuth, currency: e.target.value });
    }

    function changeToken(e) {
        isNotNullCheck(e.target.value, "WPG_token");
        setSoapVoidAuth({ ...soapVoidAuth, token: e.target.value });
    }

    function changeAuthCode(e) {
        isNotNullCheck(e.target.value, "WPG_authCode");
        setSoapVoidAuth({ ...soapVoidAuth, authCode: e.target.value });
    }

    function changeRegion(e) {
        isNotNullCheck(e.target.value, "WPG_region");
        setSoapVoidAuth({ ...soapVoidAuth, region: e.target.value });
    }

    function changeUserId(e) {
        setSoapVoidAuth({ ...soapVoidAuth, userid: e.target.value });
    }

    function changeCustomerPresent(e) {
        isNotNullCheck(e.target.value, "WPG_customerPresent");
        setSoapVoidAuth({ ...soapVoidAuth, customerPresent: e.target.value });
    }

    var region = [];

    for (var property in properties.REGIONS) {
        region.push(<option value={property} key={property}>{properties.REGIONS[property]}</option>);
    }

    async function submitVoidAuthForm(e) {
        e.preventDefault();
        isNotNullCheck(soapVoidAuth.transactionid, "WPG_transID");
        isNotNullCheck(soapVoidAuth.vendorid, "WPG_vendorID");
        isNotNullCheck(soapVoidAuth.password, "vendorPwd");
        isNotNullCheck(soapVoidAuth.description, "WPG_description");
        isNotNullCheck(soapVoidAuth.method, "WPG_method");
        isNotNullCheck(soapVoidAuth.customerPresent, "WPG_customerPresent");
        isNotNullCheck(soapVoidAuth.region, "WPG_region");
        isNotNullCheck(soapVoidAuth.token, "WPG_token");
        isNotNullCheck(soapVoidAuth.authCode, "WPG_authCode");
        isNotNullCheck(soapVoidAuth.currency, "WPG_currency");
        soapVoidAuth.timestamp = Math.floor(Date.now() / 1000);
        soapVoidAuth.timestamp = Math.floor(Date.now() / 1000);
        var md5 = require('md5');
        const requestbody =
        {
            vendorID: soapVoidAuth.vendorid,
            transID: soapVoidAuth.transactionid,
            userID: soapVoidAuth.userid,
            method: soapVoidAuth.method,
            customerPresent: soapVoidAuth.customerPresent,
            token: soapVoidAuth.token,
            authCode: soapVoidAuth.authCode,
            description: soapVoidAuth.description,
            currency: soapVoidAuth.currency,
            timestamp: soapVoidAuth.timestamp,
            region: soapVoidAuth.region,
            security: md5(soapVoidAuth.vendorid +
                soapVoidAuth.transactionid + soapVoidAuth.userid +
                soapVoidAuth.method + soapVoidAuth.customerPresent +
                soapVoidAuth.token + soapVoidAuth.authCode +
                soapVoidAuth.description +
                soapVoidAuth.currency +
                soapVoidAuth.timestamp + soapVoidAuth.region +
                soapVoidAuth.password),

        };
        var xmlBody = [];
        xmlBody.push(properties.SOAP_REQUEST_PREFIX + "<ns1:voidAuthorise>");
        for (var property in requestbody) {
            xmlBody.push("<" + property + ">" + requestbody[property] + "</" + property + ">");
        }
        xmlBody.push("</ns1:voidAuthorise>" + properties.SOAP_REQUEST_SUFFIX);
        xmlBody = xmlBody.join("\n");
        var request = {
            method: 'POST',
            headers: new Headers({
                'Accept-Type': 'text/xml',
                'Content-Type': 'text/xml'
            }),
            body: xmlBody
        };
        if (canSubmit) {
            document.getElementsByClassName("loader")[0].classList.add("loading");
            var statusCode;
            if (soapVoidAuth.region === "NoR") {
                setSoapVoidAuth({ ...soapVoidAuth, region: "" });
            }
            fetch(apiUrl, request)
                .then(resp => {
                    if (Object.keys(properties.RESPONSE_STATUS_MESSAGE).indexOf(String(resp.status)) === -1) {
                        return resp.text();
                    }
                    else {
                        statusCode = resp.status;
                        throw resp;
                    }
                })
                .then(responsedata => setResponse(<SoapResponse title="Void Authorise Response" operation="WPS_voidAuthorise" message={responsedata} />))
                .catch((error) => {
                    console.log(error);
                    setResponse(<ErrorPage code={statusCode} />);
                });
        }
    }

    useEffect(() => {
        $(".page-body").scrollTop(0);
    }, []);

    var soapVoidAuthTemplate = (
        <div className="operation-form">
            <h2>Void Authorise</h2>
            <form className="form-horizontal" method='post' onSubmit={submitVoidAuthForm}>
                <div className="form-group">
                    <div className="control-label">
                        Client Application ID<span className="mandatory-indicator">*</span>
                    </div>
                    <div className="col-sm-5">
                        <input type="text" className="form-control" name="WPG_vendorID" value={soapVoidAuth.vendorid} onChange={changeVendorId} />
                        <div className="error-msg" name="WPG_vendorID">Client Application ID is mandatory</div>
                    </div>
                </div>
                <div className="form-group">
                    <div className="control-label">
                        Transaction ID<span className="mandatory-indicator">*</span>
                    </div>
                    <div className="col-sm-5">
                        <input type="text" className="form-control" name="WPG_transID" value={soapVoidAuth.transactionid} onChange={changeTransactionId} />
                        <div className="error-msg" name="WPG_transID">Transaction ID is mandatory</div>
                    </div>
                </div>
                <div className="form-group">
                    <div className="control-label">
                        User ID
                    </div>
                    <div className="col-sm-5">
                        <input type="text" className="form-control" name="WPG_userid" value={soapVoidAuth.userid} onChange={changeUserId} />
                    </div>
                </div>
                <div className="form-group">
                    <div className="control-label">
                        Customer Present<span className="mandatory-indicator">*</span>
                    </div>
                    <div className="col-sm-5">
                        <select className="form-control" name="WPG_customerPresent" value={soapVoidAuth.customerPresent} onChange={changeCustomerPresent}>
                            <option value="Y">Yes</option>
                            <option value="N">No</option>
                        </select>
                        <div className="error-msg" name="WPG_customerPresent">Customer Present is mandatory</div>
                    </div>
                </div>
                <div className="form-group">
                    <div className="control-label">
                        Method<span className="mandatory-indicator">*</span>
                    </div>
                    <div className="col-sm-5">
                        <input type="text" className="form-control" name="WPG_method" value={soapVoidAuth.method} onChange={changeMethod} />
                        <div className="error-msg" name="WPG_method">Method is mandatory</div>
                    </div>
                </div>
                <div className="form-group">
                    <div className="control-label">
                        Description<span className="mandatory-indicator">*</span>
                    </div>
                    <div className="col-sm-5">
                        <input type="text" className="form-control" name="WPG_description" value={soapVoidAuth.description} onChange={changeDesc} />
                        <div className="error-msg" name="WPG_description">Description is mandatory</div>
                    </div>
                </div>
                <div className="form-group">
                    <div className="control-label">
                        ISO Currency Code<span className="mandatory-indicator">*</span>
                    </div>
                    <div className="col-sm-5">
                        <input type="text" className="form-control" name="WPG_currency" value={soapVoidAuth.currency} onChange={changeCurrency} />
                        <div className="error-msg" name="WPG_currency">ISO Currency Code is mandatory</div>
                    </div>
                </div>
                <div className="form-group">
                    <div className="control-label">
                        Region<span className="mandatory-indicator">*</span>
                    </div>
                    <div className="col-sm-5">
                        <select className="form-control" name="WPG_region" value={soapVoidAuth.region} onChange={changeRegion}>
                            {region}
                        </select>
                        <div className="error-msg" name="WPG_region">Region is mandatory</div>
                    </div>
                </div>
                <div className="form-group">
                    <div className="control-label">
                        Token<span className="mandatory-indicator">*</span>
                    </div>
                    <div className="col-sm-5">
                        <input type="text" className="form-control" name="WPG_token" value={soapVoidAuth.token} onChange={changeToken} />
                        <div className="error-msg" name="WPG_token">Token is mandatory</div>
                    </div>
                </div>
                <div className="form-group">
                    <div className="control-label">
                        Auth Code<span className="mandatory-indicator">*</span>
                    </div>
                    <div className="col-sm-5">
                        <input type="text" className="form-control" name="WPG_authCode" value={soapVoidAuth.authCode} onChange={changeAuthCode} />
                        <div className="error-msg" name="WPG_authCode">Auth Code is mandatory</div>
                    </div>
                </div>
                <div className="form-group">
                    <div className="control-label">
                        Client Application Password<span className="mandatory-indicator">*</span>
                    </div>
                    <div className="col-sm-5">
                        <input type="password" className="form-control" name="vendorPwd" value={soapVoidAuth.password} onChange={changePwd} />
                        <div className="error-msg" name="vendorPwd">Client Application Password is mandatory</div>
                    </div>
                </div>
                <div className="form-group">
                    <div className="col-sm-5">
                        <button type="submit" id="voidAuthButton" className="btn btn-primary">Perform</button>
                    </div>
                </div>
            </form>
            <div className="loader-div">
                <span className="loader"><LoaderComp /></span>
            </div>
        </div>

    );

    return response ? response : soapVoidAuthTemplate;
}

export default SoapVoidAuth;